import { DropzoneArea } from 'material-ui-dropzone';
import React from 'react';

export interface FileUploaderProps {
  onChange: (files: any) => void;
  onDelete?: (deletedFileObject: object) => void;
  onDrop?: (droppedFiles: any) => void;
  text?: string;
  maxFileSize?: number;
  maxFilesCount?: number;
  showFileNames?: boolean;
  acceptedFiles?: string[];
}

const FileUploader: React.FC<FileUploaderProps> = ({
  onChange,
  onDelete,
  onDrop,
  acceptedFiles,
  text,
  maxFileSize,
  maxFilesCount,
  showFileNames,
}) => {
  return (
    <DropzoneArea
      onChange={onChange}
      onDelete={onDelete}
      onDrop={onDrop}
      acceptedFiles={acceptedFiles}
      dropzoneText={text ?? 'Dosyaları sürükle-bırak yaparak veya buraya tıklayarak yükleyebilirsin'}
      maxFileSize={maxFileSize ?? 5000000}
      filesLimit={maxFilesCount ?? 5}
      showFileNames={showFileNames ?? true}
      getFileAddedMessage={(fileName: string) => `Dosya ${fileName} başarıyla eklendi`}
      getFileLimitExceedMessage={(filesLimit: number) => `Maksimuum ${filesLimit} adet dosya ekleyebilirsiniz`}
      getFileRemovedMessage={(fileName: string) => `Dosya ${fileName} başarıyla eklendi`}
    />
  );
};

export default FileUploader;
